export default __webpack_public_path__ + "static/media/logo-h-w-new.00f0cf41.png";